import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'facility-edit',
  data: function () {
    return {
      shopId: null,
      facilityId: null,
      facilityHistoryId: null,
      isEditMode: false,
      isDisplay: false,
      isFacility: true,         // 施設
      isFacilityPerson: false,  // 個人宅
      isShopSearchCallback: false,
      isPhraseSearchCallback: false,

      /** 変更日 */
      change_date: null,

      /** 施設情報 */
      facility: {
        facility_name          : null,
        facility_name_furigana : null,
        company_name           : null,
        facility_type          : null,
        main_clinic            : null,
        prescription_receive   : null,
        post_no                : null,
        address1               : null,
        address2               : null,
        tel                    : null,
        fax                    : null,
        email                  : null,
        boss_name              : null,
        medman1_name           : null,
        medman2_name           : null,
        deli_date_type         : null,
        deli_day_other         : null,
        deli_time              : null,
        deli_note              : null,
        med_storage            : null,
        package                : null,
        package_set            : null,
        package_set_other      : null,
        manual                 : null,
        hotchkiss              : null,
        hotchkiss_other        : null,
        stamp_type             : null,
        stamp_date             : null,
        stamp_name             : null,
        stamp_time             : null,
        stamp_method           : null,
        stamp_clinic           : null,
        stamp_medicine         : null,
        stamp_width            : null,
        stamp_other            : null,
        stamp_svg              : null,
        enable_flag            : null,
        map_lat                : null,
        map_lng                : null,
        map_zoom               : null,
        send_type              : null,
        send_timing            : null,
        send_timing_hour       : null,
        bill_type              : null,
        remnant_alert_timing   : null,
        // create_time            : null,
        // update_time            : null,
        // del_flag               : null,
        // encrypted_password     : null,
        // reset_password_token   : null,
        // reset_password_sent_at : null,
        // remember_created_at    : null,
        // sign_in_count          : null,
        // current_sign_in_at     : null,
        // last_sign_in_at        : null,
        // current_sign_in_ip     : null,
        // last_sign_in_ip        : null,
        // created_at             : null,
        // updated_at             : null,
        // access_token           : null,
        start_date             : null,
        end_date               : null,

        login_id               : null,
        password               : null,
        facility_code          : null,

        charge_shop_ids        : [],
        notices                : [],
        floors                 : [],
        pays                   : [],
        images                 : [],
        deli_days              : [],
      },

      /** 行追加する項目 */
      newNotice: null,
      newFloor: null,

      /** チェックボックス */
      send_types: [],
      packages: [],
      package_sets: [],
      manuals: [],
      hotchkisses: [],

      /** 配達日ラベル */
      deliday_label: null,
      /** 配達日(モーダル) */
      deliday_modal: {
        deli_date_type: null,
        deli_day_0: null,
        deli_day_1_0: null,
        deli_day_1_1: null,
        deli_day_1_2: null,
        deli_day_1_3: null,
        deli_day_1_4: null,
        deli_days: null,
        deli_day_other: null
      },

      /** 画像タイトル編集 */
      editImageTitle: null,
      /** ログインID先頭文字 */
      login_id_prefix: null
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.googleMapEventRemove() // google map イベント削除
    next()
  },
  created: function() {
    var self = this

    this.shopId = this.$store.getters.currentShopId
    // ログインID先頭文字
    this.login_id_prefix = constant.facility.login_id_prefix

    if (this.$route.name === 'facilityEdit') {
      // 施設編集
      this.isEditMode = true
      this.isFacility = true
      this.isFacilityPerson = false
    } else if (this.$route.name === 'facilityRegist') {
      // 施設新規登録
      this.isEditMode = false
      this.isFacility = true
      this.isFacilityPerson = false
    } else if (this.$route.name === 'facilityPersonEdit') {
      // 個人宅編集
      this.isEditMode = true
      this.isFacility = false
      this.isFacilityPerson = true
    } else if (this.$route.name === 'facilityPersonRegist') {
      // 個人宅新規登録
      this.isEditMode = false
      this.isFacility = false
      this.isFacilityPerson = true
    }

    // 店舗
    // this.$store.dispatch('SHOP_SEARCH')
    this.isShopSearchCallback = false
    var shopSearchCallback = function () {
      self.isShopSearchCallback = true
    }
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: shopSearchCallback})

    // 施設タイプ
    this.isPhraseSearchCallback = false
    var phraseSearchCallback = function () {
      self.isPhraseSearchCallback = true
    }
    this.$store.dispatch('PHRASE_SEARCH', {data:{phrase_type: constant.phraseType.FACILITY_TYPE}, type: 'combobox', callback: phraseSearchCallback})

    if (this.isEditMode) {
      if (this.$route.params.facilityId === undefined || this.$route.params.facilityHistoryId === undefined) {
       // エラー
      } else {
        this.facilityId = this.$route.params.facilityId
        this.facilityHistoryId = this.$route.params.facilityHistoryId
      }
      // 施設履歴の取得
      this.showFacility(this.facilityId, this.facilityHistoryId)
    } else {
      /** 新規作成 */
      this.newInstance()
    }
    // 行追加項目初期化
    this.initNewNotice()
    this.initNewFloor()
  },
  mounted: function () {
    if (this.$route.name === 'facilityEdit' || this.$route.name === 'facilityPersonEdit') {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
    // google map 表示
    utils.googleMapEvent({
      js:          constant.js.google_maps,
      key:         config.google_map_api_key,
      mapElmId:    'map',
      lat:         null,
      lng:         null,
      zoom:        null,
      map_default: constant.map_default,
      mapCallback: this.mapCallback,
    })
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    shops () {
      return this.$store.getters.shops.filter((o) => {return o.id != null}) // 全店舗は不可
    },
    userName() {
      return this.$store.getters.userName
    },
    /** 通知 */
    notify () {
      return this.$store.getters.facilityEditNotify
    },
    uploadCounter () {
      var total = this.$store.getters.imageUploadTotal
      var current = this.$store.getters.imageUploadCurrent
      if (total < 1 || total === current) {
        return ''
      } else {
        return this.$t('Count', {'Count': current + '/' + total}) + this.$t('Image Upload Successful')
      }
    },
    uploadErrors () {
      return this.$store.getters.imageUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.imageUploadStatus
    },
    /** 曜日 */
    week_days () {
      var arr = [{'id': null, 'text': ''}]
      Array.prototype.push.apply(arr, this.$t('week_days'))
      return arr
    },
    /** スタンプタイプを取得*/
    stampType () {
      let stampTypes = constant.facility.stamp_types
      return this.$t('facility.stamp_types')
    },
    /** 送付方法 */
    sendTypes () {
      return this.$t('facility.send_types')
    },
    /** 送信タイミング */
    sendTiming () {
      return this.$t('facility.send_timing')
    },
    /** 送信タイミング時間 */
    sendTimingHour () {
      return this.$t('facility.send_timing_hour')
    },
    /** 午前/午後 */
    amPm () {
      return this.$t('facility.am_pm')
    },
    /** パッケージ */
    facilityPackages () {
      return this.$t('facility.packages')
    },
    /** パッケージセット */
    facilityPackageSets () {
      return this.$t('facility.package_sets')
    },
    /** マニュアル */
    facilityManuals () {
      return this.$t('facility.manuals')
    },
    /** ホッチキス */
    facilityHotchkisses () {
      return this.$t('facility.hotchkisses')
    },
    /** 支払いフォーマット */
    facilityPayFormats () {
      return this.$t('facility.pay_formats')
    },
    /** 支払いオプション */
    facilityPayOptions () {
      return this.$t('facility.pay_options')
    },

    /** 定型文-施設種類 を取得 */
    facilityTypes () {
      var arr = [{id: null, attributes: {'phrase-type-id': null, 'phrase-code': null, 'phrase': ''}}]
      Array.prototype.push.apply(arr, this.$store.getters.phraseLists[constant.phraseType.FACILITY_TYPE])
      var result = []
      for (var i = 0; i < arr.length; i++) {
        if (utils.str2int(arr[i].attributes['phrase-code']) !== 1) {
          result.push(arr[i])
        }
      }
      return result
    },

    /** 削除ボタンが押された行は表示しない */
    filteredNotices () {
      return this.facility.notices.filter(function(item, index) {
        if (item.attributes['del-flag'] === 0) return true
      })
    },
    filteredFloors () {
      return this.facility.floors.filter(function(item, index) {
        if (item.attributes['del-flag'] === false) return true
      })
    },
    filteredImages () {
      return this.facility.images.filter(function(item, index) {
        if (item.del_flag === 0) return true
      })
    },
    /** 注意事項 完了期限日付バリデーション */
    limitDateValidation () {
      let noticeLimitDates = []
      for (let i in this.filteredNotices){
        noticeLimitDates[i] = !utils.isWareki(this.$t, this.filteredNotices[i].attributes['limit-date'])
      }
      return noticeLimitDates
    },

    required: function() {
      return {
        facility_type:                 (utils.isBlank(this.facility.facility_type) && this.isFacility),
        facility_name:                 utils.isBlank(this.facility.facility_name),
        post_no:                       utils.isBlank(this.facility.post_no),
        address1:                      utils.isBlank(this.facility.address1),
        address2:                      utils.isBlank(this.facility.address2),
        tel:                           utils.isBlank(this.facility.tel),
        fax:                           utils.isBlank(this.facility.fax),
        // email:                         utils.isBlank(this.facility.email),
        send_types:                    !(this.send_types.length > 0),
        charge_shop_ids:               !(this.facility.charge_shop_ids.length > 0),
        facility_name_furigana_format: !utils.isHiragana(this.facility.facility_name_furigana, false),
        tel_format:                    !utils.isPhone(this.facility.tel),
        fax_format:                    !utils.isPhone(this.facility.fax),
        email_format:                  !utils.isEmail(this.facility.email),
        post_no_format:                !utils.isPostNo(this.facility.post_no),
        limit_date_format:             !this.limitDateValidation.every(function (x) { return !x }),
        change_date_format:            !utils.isWareki(this.$t, this.facility.change_date, true),
        // TODO: 未来日の編集を禁止する場合
        future_date:                   utils.wareki2Seireki(this.$t, this.change_date) > new Date
      }
    },
    /** 保存ボタン押下可否 */
    isValid () {
      var required = this.required
      return Object.keys(required).every(function (key) {
        return !required[key]
      })
    },

    /** 配達日モーダルバリデーション */
    requiredDeliday () {
      return {
        0: utils.isBlank(this.deliday_modal.deli_day_0),
        1: ![this.deliday_modal.deli_day_1_0, this.deliday_modal.deli_day_1_1, this.deliday_modal.deli_day_1_2, this.deliday_modal.deli_day_1_3, this.deliday_modal.deli_day_1_4],
        2: !this.deliday_modal.deli_days,
        3: !this.deliday_modal.deli_day_other
      }
    },
    /** 配達日モーダル OKボタン押下可否 */
    canInputDeliday: function () {
      return !this.requiredDeliday[this.deliday_modal.deli_date_type]
    },
    /** フロア追加可否 */
    canAddFloor: function () {
      if (this.newFloor === undefined) {
        return false
      }
      return !utils.isBlank(this.newFloor.attributes['floor-code']) && !utils.isBlank(this.newFloor.attributes['floor-name'])
    },
    /** 注意事項 追加可否 */
    canAddNotice: function () {
      if (this.newNotice === undefined) {
        return false
      }
      return this.newNotice.attributes['notice'] !== ""
    },
    /** 画像登録ボタン 押下可否 */
    canAddImage: function () {
      return this.filteredImages.length < constant.place_image_upload_limit
    },
    /** ローディング */
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 基準日 */
    referenceDate () {
      if (this.facility !== null) {
        var start = utils.sereki2Wareki(this.$t, new Date(this.facility.start_date))
        var end = new Date(this.facility.end_date)
        if (end.getFullYear() === this.$t('history.max_year')) {
          end = this.$t('history.max_display')
        } else {
          end = utils.sereki2Wareki(this.$t, end)
        }
        return start + this.$t('history.delimiter') + end
      } else {
        return ''
      }
    }
  },
  methods: {
    /***************************************
     *  リンク系
     ***************************************/
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
    },

    /** 前へ戻る */
    goPrev: function () {
      if (this.isFacilityPerson && utils.isBlank(this.$route.params.facilityId)) {
        // 個人宅新規作成 → 個人宅一覧
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.isFacilityPerson) {
        // 個人宅編集 → 個人宅詳細
        this.$router.push({path: '/facility_persons/detail/'+ this.$route.params.facilityId, query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$route.params.facilityId !== undefined) {
        this.$router.push({path: '/facilities/detail/'+ this.$route.params.facilityId, query: {type: this.$router.currentRoute.query.type}})
      } else {
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    },

    /***************************************
     *  初期表示系
     ***************************************/
    /** 施設(履歴)情報取得 */
    showFacility: function (facilityId, facilityHistoryId) {
      this.$store.dispatch('FACILITY_HISTORY_GET',{
        data:{ facility_id: facilityId, facility_history_id: facilityHistoryId, shop_id: this.shopId },
        callback: this.callbackGetFacilityData
      })
    },
    /** 施設情報格納 */
    callbackGetFacilityData: function (data) {
      var facility = data.facility
      var images = data.images
      for (var key in this.facility) {
        this.facility[key] = facility[key]
      }
      this.packages = utils.bitvalue2group(
        facility.package,
        this.facilityPackages
      )
      this.package_sets = utils.bitvalue2group(
        facility.package_set,
        this.facilityPackageSets
      )
      this.manuals = utils.bitvalue2group(
        facility.manual,
        this.facilityManuals
      )
      this.hotchkisses = utils.bitvalue2group(
        facility.hotchkiss,
        this.facilityHotchkisses
      )
      this.send_types = utils.bitvalue2group(
        facility.send_type,
        this.sendTypes
      )
      this.facility.notices = facility.notices.data
      this.facility.floors = facility.floors.data
      // this.facility.images = facility.images.data
      this.facility.images = images
      this.deliday_label = this.delidayLabel(this.facility)

      // 印字描画
      if (this.facility.stamp_svg === null) {
        if (this.facility.stamp_type === null) {
          this.getStampSvg(constant.facility.default.stamp_type) // 'A'
        } else {
          this.getStampSvg(this.facility.stamp_type)
        }
      }

      // GoogleMaps 更新
      utils.googleMapEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        lat:         this.facility.map_lat,
        lng:         this.facility.map_lng,
        zoom:        this.facility.map_zoom,
        mapCallback: this.mapCallback,
        map_default: constant.map_default,
      })

      this.isDisplay = true
    },
    /** 初期データ */
    newInstance: function () {
      this.facility.map_lat = null
      this.facility.map_lng = null
      this.facility.map_zoom = null
      this.facility.send_timing = constant.facility.default.send_timing
      this.facility.send_timing_hour = constant.facility.default.send_timing_hour

      /** 注意事項 */
      this.facility.notices = []
      /** 施設フロア */
      this.facility.floors = []

      /** 印字編集 */
      this.facility.stamp_type = constant.facility.default.stamp_type
      this.facility.stamp_width = constant.facility.default.stamp_width
      this.getStampSvg(this.facility.stamp_type)

      /** 支払情報 */
      this.facility.pays = constant.facility.pays

      // 自店舗デフォルト
      this.facility.charge_shop_ids = [this.shopId]

      /** 個人宅施設タイプ */
      if (this.isFacilityPerson) {
        this.facility.facility_type = constant.facility.facility_person_type // 1
      }

      this.isDisplay = true
    },

    /***************************************
     *  イベント系
     ***************************************/

    /** GoogleMaps */
    /** クリック時コールバック */
    mapCallback: function(lat, lng, zoom) {
      this.facility.map_lat = lat
      this.facility.map_lng = lng
      this.facility.map_zoom = zoom
    },
    /** マーククリア */
    onClickMapMarkClear: function () {
      utils.googleMapEventMarkaClear()
      this.facility.map_lat = null
      this.facility.map_lng = null
      this.facility.map_zoom = null
    },

    /*** 施設注意事項 ***/
    /** 注意事項 追加行*/
    initNewNotice: function () {
      this.newNotice = {
        id: null,
        type: 'facility-notice',
        attributes: {
          'facility-notice-id': null,
          'notice': "",
          'creator-name': this.userName,
          'input-date': utils.sereki2Wareki(this.$t, new Date),
          'complete-flag': constant.facility.complete_flag.off, // 0
          'del-flag': constant.facility.del_flag.off, // 0
          'limit-date': ""
        }
      }
    },

    /** 注意事項 追加ボタン押下 */
    addNotice: function () {
      if (this.canAddNotice) {
        this.newNotice.attributes['creator-name'] = this.userName
        this.facility.notices.push(this.newNotice)
        this.initNewNotice()
      }
    },
    /** 注意事項 完了ボタン押下 */
    completeNotice: function (notice){
      notice.attributes['complete-flag'] = constant.facility.complete_flag.on // 1
    },
    /** 注意事項 削除ボタン押下 */
    removeNotice: function (notice) {
      notice.attributes['del-flag'] = constant.facility.del_flag.on // 1
    },

    /*** 施設フロア ***/
    /** フロア追加行 */
    initNewFloor: function () {
      this.newFloor = {
        attributes: {
          'facility-floor-id': null,
          'floor-code': "",
          'floor-name': "",
          'del-flag': false
        }
      }
    },

    /** フロア 行追加ボタン押下 */
    addFloor: function () {
      if (this.canAddFloor) {
        this.facility.floors.push(this.newFloor)
        this.initNewFloor()
      }
    },
    /** フロア 削除ボタン押下 */
    removeFloor: function (floor) {
      floor.attributes['del-flag'] = true
    },

    /** 郵便番号入力補助 */
    onChangePostNo: function () {
      if (!!this.facility.post_no && utils.regex.post_no.test(this.facility.post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.facility.post_no, callback: (addr) => {
            if (addr) {
              this.facility.address1 = addr.address1
              this.facility.address2 = addr.address2
              this.onChangeAddress()
            }
          }
        })
      }
    },

    /** 住所変更時イベント */
    onChangeAddress: function () {
      var arr = []
      if (utils.isPresent(this.facility.post_no)) arr.push(this.facility.post_no)
      if (utils.isPresent(this.facility.address1)) arr.push(this.facility.address1)
      if (utils.isPresent(this.facility.address2)) arr.push(this.facility.address2)
      // if (utils.isPresent(this.facility.facility_name)) arr.push(this.facility.facility_name)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },

    /** 配達日モーダル表示 */
    onClickDelidayModalShow: function () {
      // モーダル用変数に格納
      if (this.facility.deli_date_type === 0) {
        this.deliday_modal.deli_day_0 = this.facility.deli_days[0]
      } else if (this.facility.deli_date_type === 1) {
        this.deliday_modal.deli_day_1_0 = this.facility.deli_days[0]
        this.deliday_modal.deli_day_1_1 = this.facility.deli_days[1]
        this.deliday_modal.deli_day_1_2 = this.facility.deli_days[2]
        this.deliday_modal.deli_day_1_3 = this.facility.deli_days[3]
        this.deliday_modal.deli_day_1_4 = this.facility.deli_days[4]
      } else if (this.facility.deli_date_type === 2) {
        this.deliday_modal.deli_days = this.facility.deli_days.join(',')
      } else if (this.facility.deli_date_type === 3) {
        this.deliday_modal.deli_day_other = this.facility.deli_day_other
      }

      this.deliday_modal.deli_date_type = this.facility.deli_date_type
      var button = document.getElementById('deliday_modal_button')
      button.click() // モーダル表示 イベント発火
    },
    /** 配達日ダイアログ OKボタン押下 */
    inputDeliday: function () {
      if (this.deliday_modal.deli_date_type !== undefined || this.deliday_modal.deli_date_type !== null) {
        this.deliday_modal.deli_date_type = parseInt(this.deliday_modal.deli_date_type, 10)
      }
      if ( this.deliday_modal.deli_date_type === constant.facility.deli_date_type.reception_day) {
        this.facility.deli_days = [this.deliday_modal.deli_day_0]
      } else if ( this.deliday_modal.deli_date_type === constant.facility.deli_date_type.every_week ) {
        this.facility.deli_days = [this.deliday_modal.deli_day_1_0, this.deliday_modal.deli_day_1_1, this.deliday_modal.deli_day_1_2, this.deliday_modal.deli_day_1_3, this.deliday_modal.deli_day_1_4]
      } else if ( this.deliday_modal.deli_date_type === constant.facility.deli_date_type.every_month ) {
        this.facility.deli_days = this.deliday_modal.deli_days.split(',')
      } else if ( this.deliday_modal.deli_date_type === constant.facility.deli_date_type.other ) {
        this.facility.deli_day_other = this.deliday_modal.deli_day_other
      }
      this.facility.deli_date_type = this.deliday_modal.deli_date_type

      // ラベル更新
      this.deliday_label = this.delidayLabel(this.facility)
    },
    /** 配達日ラベル */
    delidayLabel: function (facility) {
      if (facility.deli_date_type === null || facility.deli_date_type === undefined) {
        return ''
      }
      var deli_date_type = parseInt(facility.deli_date_type, 10)
      var txt = ''
      if (deli_date_type === constant.facility.deli_date_type.reception_day) {
        if (facility.deli_days[0] !== undefined && facility.deli_days[0] !== null) {
          return this.$t('facility.reception_day') + utils.id2text(this.$t('week_days'), facility.deli_days[0])
        }
      } else if (deli_date_type === constant.facility.deli_date_type.every_week) {
        txt = this.$t('facility.every_week')
        if ( !utils.isBlank(facility.deli_days[0]) )
            txt += ' '+ this.$t('facility.first') + utils.id2text(this.$t('week_days'), facility.deli_days[0])
        if ( !utils.isBlank(facility.deli_days[1]) )
            txt += ' '+ this.$t('facility.second') + utils.id2text(this.$t('week_days'), facility.deli_days[1])
        if ( !utils.isBlank(facility.deli_days[2]) )
            txt += ' '+ this.$t('facility.third') + utils.id2text(this.$t('week_days'), facility.deli_days[2])
        if ( !utils.isBlank(facility.deli_days[3]) )
            txt += ' '+ this.$t('facility.fourth') + utils.id2text(this.$t('week_days'), facility.deli_days[3])
        if ( !utils.isBlank(facility.deli_days[4]) )
            txt += ' '+ this.$t('facility.fifth') + utils.id2text(this.$t('week_days'), facility.deli_days[4])
      } else if (deli_date_type === constant.facility.deli_date_type.every_month) {
        txt = this.$t('facility.every_month')
        for (var i in facility.deli_days) {
          txt += facility.deli_days[i] + this.$t('facility.day') + ' '
        }
      } else if (deli_date_type === constant.facility.deli_date_type.other) {
        txt = this.$t('facility.other') + facility.deli_day_other
      }
      return txt
    },
    /** 毎月ｎ日の入力チェック(モーダル) */
    checkDays: function () {
      let deli_days = this.deliday_modal.deli_days

      if (deli_days === undefined || deli_days === null) {
        this.deliday_modal.deli_days = ''
        return
      }

      deli_days = deli_days.replace(/１/g, '1')
      deli_days = deli_days.replace(/２/g, '2')
      deli_days = deli_days.replace(/３/g, '3')
      deli_days = deli_days.replace(/４/g, '4')
      deli_days = deli_days.replace(/５/g, '5')
      deli_days = deli_days.replace(/６/g, '6')
      deli_days = deli_days.replace(/７/g, '7')
      deli_days = deli_days.replace(/８/g, '8')
      deli_days = deli_days.replace(/９/g, '9')
      deli_days = deli_days.replace(/０/g, '0')
      deli_days = deli_days.replace(/、/g, ',')
      deli_days = deli_days.replace(/，/g, ',')
      deli_days = deli_days.replace(/\./g, ',')
      deli_days = deli_days.replace(/\ /g, '')
      deli_days = deli_days.replace(/\　/g, '')
      deli_days = deli_days.replace(/^,+/g, '')
      deli_days = deli_days.replace(/,+$/g, '')

      let days = deli_days.split(',')
      let new_days = []
      for (let i in days) {
        days[i] = parseInt(days[i], 10)
        if (days[i] >= 1 && days[i] <= 31) {
          if (new_days.indexOf(days[i]) < 0) {
            new_days.push(days[i])
          }
        }
      }

      new_days.sort(function(a, b){
        return a > b
      })

      this.deliday_modal.deli_days = new_days.join(',')

      return
    },

    /** 印字モーダル表示 */
    onClickSvgModalShow: function() {
      // 印字
      var svgEditorFrame = document.getElementById('svgEditorFrame')
      var button = document.getElementById('svg_modal_button')
      // データ
      window.localStorage.setItem("svg-edit-lang", "ja")
      window.localStorage.setItem("svgedit-default", this.facility.stamp_svg)
      // URL
      if (("" + svgEditorFrame.src).indexOf('svg-edit') < 0) {
        svgEditorFrame.src = './static/svg-edit/index.html'
      }
      // svgEditorFrame.contentWindow.svgEditor.canvas.setSvgString(this.facility.stamp_svg)
      button.click() // モーダル表示
    },
    /** 印字モーダル 保存処理 */
    onClickSvgModalOk: function() {
      // 印字
      var svgEditorFrame = document.getElementById('svgEditorFrame')
      this.facility.stamp_svg = svgEditorFrame.contentWindow.svgEditor.canvas.getSvgString()
      // window.localStorage.setItem("svgedit-default", '')
    },
    /** 印字SVG取得 */
    getStampSvg: function (selectedTypeId) {
      var newStampSvg = constant.facility.stamp_types.filter(function(type, index){
        if (type.id === selectedTypeId) return true
      })
      // 表示中のSVGを変更
      this.facility.stamp_svg = newStampSvg[0].svg
    },

    /** 支払方法 オプションが変更された場合 */
    onChangePdfOption: function() {
      var elm = document.querySelectorAll('div.pdf-option-parent')
      var idx = 0
      var pays = [elm.length]
      Array.prototype.map.apply(elm, [function (e) {
        var checkboxList = e.querySelectorAll('input.pdf-option')
        pays[idx] = 0
        Array.prototype.map.apply(checkboxList, [function (checkbox) {
          if (checkbox.checked === true) {
            pays[idx] += parseInt(checkbox.value, 10)
          }
        }])
        idx += 1
      }])
      for (var i = 0; i < pays.length; i++) {
        this.facility.pays[i].pdf_option = pays[i]
      }
    },

    /***************************************
     *  保存系
     ***************************************/
    /** 保存ボタン押下 */
    onClickSave: function () {
      if (this.isValid) {
        // フロアーコード入力チェック
        if (!this.checkDuplicateFloorCode()) {
          this.$store.dispatch('FACILITY_CODE_DUPLICATE')
          return
        }

        // 電話番号重複チェック
        this.$store.dispatch('FACILITY_DUPLICATE_CHECK', {
          data: {
            facility_id: this.facilityId,
            tel: this.facility.tel
          },
          callback: (result) => {
            if (result) {
              // 電話番号重複あり、確認ダイアログ表示
              this.telConfModalShow()
            } else {
              // 施設履歴データ保存
              this.saveFacilityHistory()
            }
          }
        })
      }
    },
    /** 施設履歴データを保存します. */
    saveFacilityHistory: function() {
      this.facility.package = utils.group2bitvalue(this.packages)
      this.facility.package_set = utils.group2bitvalue(this.package_sets)
      this.facility.manual = utils.group2bitvalue(this.manuals)
      this.facility.hotchkiss = utils.group2bitvalue(this.hotchkisses)
      this.facility.send_type = utils.group2bitvalue(this.send_types)
      this.facility.deli_days = this.facility.deli_days.map(function (days) {
        return utils.isBlank(days) ?  '' : String(days)
      })
      // 新規作成
      if (!this.isEditMode) {
        this.facility.enable_flag = 1
      }
      var data = {
        facility_id:         this.facilityId,
        facility_history_id: this.facilityHistoryId,
        change_date:         utils.wareki2Seireki(this.$t, this.change_date, 'y-m-d'),
        facility_code:       this.facility.facility_code,
        charge_shop_ids:     this.facility.charge_shop_ids,
        shop_id:             parseInt(this.shopId, 10),
        facility_history:    this.getFacilityHistorySaveData(),
        facility:            this.getFacilitySaveData(),
        facility_notice:     this.facility.notices,
        fac_deliday:         this.facility.deli_days,
        facility_floor:      this.facility.floors,
        facility_pay:        this.facility.pays,
        images:              this.facility.images
      }
      console.log(data)
      this.$store.dispatch('FACILITY_HISTORY_SAVE', {data: data, callback: this.onSaved})
    },

    /** 施設履歴データを取得します. */
    getFacilityHistorySaveData: function() {
      return {
        address1               : this.facility.address1,
        address2               : this.facility.address2,
        boss_name              : this.facility.boss_name,
        company_name           : this.facility.company_name,
        deli_date_type         : this.facility.deli_date_type,
        deli_day_other         : this.facility.deli_day_other,
        deli_note              : this.facility.deli_note,
        deli_time              : this.facility.deli_time,
        email                  : this.facility.email,
        enable_flag            : this.facility.enable_flag,
        facility_name          : this.facility.facility_name,
        facility_name_furigana : this.facility.facility_name_furigana,
        facility_type          : this.facility.facility_type,
        fax                    : this.facility.fax,
        hotchkiss              : this.facility.hotchkiss,
        hotchkiss_other        : this.facility.hotchkiss_other,
        login_id               : this.facility.login_id,
        main_clinic            : this.facility.main_clinic,
        manual                 : this.facility.manual,
        map_lat                : this.facility.map_lat,
        map_lng                : this.facility.map_lng,
        map_zoom               : this.facility.map_zoom,
        med_storage            : this.facility.med_storage,
        medman1_name           : this.facility.medman1_name,
        medman2_name           : this.facility.medman2_name,
        package                : this.facility.package,
        package_set            : this.facility.package_set,
        package_set_other      : this.facility.package_set_other,
        password               : this.facility.password,
        post_no                : this.facility.post_no,
        send_timing            : this.facility.send_timing,
        send_timing_hour       : this.facility.send_timing_hour,
        send_type              : this.facility.send_type,
        stamp_other            : this.facility.stamp_other,
        stamp_svg              : this.facility.stamp_svg,
        stamp_type             : this.facility.stamp_type,
        stamp_width            : this.facility.stamp_width,
        tel                    : this.facility.tel,
        prescription_receive   : this.facility.prescription_receive,
        stamp_date             : this.facility.stamp_date,
        stamp_name             : this.facility.stamp_name,
        stamp_time             : this.facility.stamp_time,
        stamp_method           : this.facility.stamp_method,
        stamp_clinic           : this.facility.stamp_clinic,
        stamp_medicine         : this.facility.stamp_medicine,
        bill_type              : this.facility.bill_type,
        remnant_alert_timing   : this.facility.remnant_alert_timing,
      }
    },
    /** 施設履歴データを取得します. */
    getFacilitySaveData: function() {
      return {
        facility_id:   this.facilityId,
        facility_name: this.facility.facility_name,
        facility_type: this.facility.facility_type,
        address1:      this.facility.address1,
        address2:      this.facility.address2,
        login_id:      this.facility.login_id,
        password:      this.facility.password,
      }
    },
    /** 保存完了後の処理 */
    onSaved: function () {
      if (this.$route.name === 'facilityEdit') {
        // 施設編集 後
        this.$router.push({path: '/facilities/detail/' + this.$route.params.facilityId, query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$route.name === 'facilityRegist') {
        // 新規登録 後
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$route.name === 'facilityPersonEdit') {
        // 個人宅編集 後
        this.$router.push({path: '/facility_persons/detail/' + this.$route.params.facilityId, query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$route.name === 'facilityPersonRegist') {
        // 個人宅登録 後
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type}})
      }
    },
    /***************************************
     *  確認・状態確認系
     ***************************************/
    /** フロアコードチェック */
    checkDuplicateFloorCode: function () {
      if (this.facility.floors && this.facility.floors.length > 1) {
        for (var i = 0; i < this.facility.floors.length; i++) {
          for (var j = (i + 1); j < this.facility.floors.length; j++) {
            if (this.facility.floors[i].attributes['floor-code'] === this.facility.floors[j].attributes['floor-code'] ) {
              return false
            }
          }
        }
      }
      return true
    },
    /** 電話番号重複ダイアログ 表示 */
    telConfModalShow: function () {
      var button = document.getElementById('confirm_duplicate_tel_modal_button')
      button.click() // モーダル表示 イベント発火
    },
    /** 電話番号重複ダイアログ OKボタン押下 */
    onClickTelConfModalOk: function () {
      this.saveFacilityHistory()
    },
    /***************************************
     *  画像アップロード系
     ***************************************/
    /** 画像押下 */
    onClickImageModalShow: function (image) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = image.image_path + '?token=' + this.authToken
      text.textContent = image.title
      button.click() // モーダル表示 イベント発火
    },
    /** 画像タイトルリンク押下 */
    onClickTitleEditModalShow: function (image) {
      this.selectedImage = image
      this.editImageTitle = image.title
      // this.editImageTitle = image.attributes['title']
      // this.editImageIndex = index
      this.$refs.editTitleBtn.click()
      // button.click() // モーダル表示 イベント発火
    },
    saveTitle: function () {
      this.selectedImage.title = this.editImageTitle
    },
    /** 画像登録ボタン 押下 */
    onClickUploadModalShow: function () {
      if (this.canAddImage) {
        var button = document.getElementById('images_upload_modal_button')
        button.click() // モーダル表示 イベント発火
        this.uploadStart()
      }
    },

    /** 画像の削除 */
    removeImage: function (image) {
      if (image) image.del_flag = constant.facility.del_flag.on // 1
    },

    onDragOver: function (event) {
      var files = event.dataTransfer.items
      if (files && (files.length + this.filteredImages.length > constant.place_image_upload_limit)) {
        event.dataTransfer.dropEffect = "none"
      }
      event.preventDefault()
    },
    onDrop: function (event) {
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      if (this.canAddImage) {
        var files = event.dataTransfer.files
        this.upload(files)
      }
    },
    onFileChange: function (event) {

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },
    uploadStart: function () {
      this.$store.dispatch('IMAGE_UPLOAD_START')
    },
    upload: function (files) {
      if (!files)
        return
      if (files.length + this.filteredImages.length > constant.place_image_upload_limit)
        return
      for (var i=0; i<files.length; i++) {
        var formData = new FormData()
        formData.append('image_attach[cache_id]', files[i])
        this.$store.dispatch('IMAGE_UPLOAD', { data: formData, callback: this.onUpload })
      }
    },
    onUpload: function (data) {
      var img = {}
      img.id              = null
      img.title           = data.title
      img.image_attach_id = null
      img.cache_id        = data.cache_id
      img.cache_id_cache  = data.cache_id_cache
      img.image_path      = data.image_path
      img.del_flag        = constant.facility.del_flag.off
      this.facility.images.push(img)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facility-edit.js